import React, { useState, useEffect } from 'react';
import firebase from 'firebase';
import Moment from 'moment';
import _ from 'lodash';

import FilterLocation from '../components/FilterLocation';
import FilterDate from '../components/FilterDate';
import FilterStatus from '../components/FilterStatus';

function Orders() {
  const [isLoading, setLoadingStatus] = useState(true);
  const [orders, setOrders] = useState([]);

  const [selectedLocation, setLocation] = useState('');
  const [selectedStatus, setStatus] = useState('');
  const [sortedBy, setSortedBy] = useState('newest');

  useEffect(() => {
    (async function() {
      let ordersFromFirebase = [];
      // TODO: make orders .on(value)
      // pull orders from firebase
      const getOrdersFromFirebase = await firebase.database().ref('orders').once('value');

      getOrdersFromFirebase.forEach((order) => {
        Object.keys(order.val()).forEach(orderId => {
          ordersFromFirebase.push({
            userId: order.key,
            orderId,
            ...order.val()[orderId],
          });
        });
      });

      // filter orders by location
      ordersFromFirebase = ordersFromFirebase.filter(order => selectedLocation === '' || selectedLocation === order.locationId);
      // filter orders by status
      ordersFromFirebase = ordersFromFirebase.filter(order => selectedStatus === '' || selectedStatus === order.status);

      // sort the orders by oldest/newest values
      if (sortedBy === 'newest') {
        ordersFromFirebase = _.orderBy(ordersFromFirebase, ['createdAt'], ['desc']);
      } else {
        ordersFromFirebase = _.orderBy(ordersFromFirebase, ['createdAt'], ['asc']);
      }

      setLoadingStatus(false);
      setOrders(ordersFromFirebase);
    }());
  }, [selectedLocation, selectedStatus, sortedBy]);

  const renderOrders = () => {
    if (isLoading) return <React.Fragment />;

    return (
      <table className="table">
        <thead>
          <tr>
            <th>View Order</th>
            <th>User Email</th>
            <th>Drop-Off Method</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {orders.map(({ orderId, userId, dropOffMethod, userEmail, createdAt, status }) => (
            <tr key={orderId}>
              <td><a href={`/order/${userId}/${orderId}`}>Order Link</a></td>
              <td>{userEmail}</td>
              <td>{dropOffMethod.text}</td>
              <td>{Moment(createdAt).format('MM/DD/YYYY')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div>
      <h3 className="page-header">Orders</h3>
      <div className="row">
        <div className="col-xs-12 col-md-4">
          <FilterLocation onChange={event => setLocation(event.target.value)} />
        </div>
        <div className="col-xs-12 col-md-4">
          <FilterDate onChange={event => setSortedBy(event.target.value)} />
        </div>
        <div className="col-xs-12 col-md-4">
          <FilterStatus onChange={event => setStatus(event.target.value)} />
        </div>
      </div>

      {renderOrders()}
    </div>
  );
}

export default Orders;
